"use strict";

require("core-js/modules/es.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoomContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ZoomContext = _react["default"].createContext({
  scale: 1
});

exports.ZoomContext = ZoomContext;


//////////////////
// WEBPACK FOOTER
// ./~/@storybook/components/dist/blocks/ZoomContext.js
// module id = 309
// module chunks = 27180705640166